module.exports = __webpack_public_path__ + "static/media/404.4a7e86ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/404.svg
// module id = 724
// module chunks = 0